/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import * as Yup from 'yup';

import { DefaultLanguage, KubernetesIdentifier } from 'shared';

import { getDummyArray } from '../../utils/getDummyArray';
import { CreateOrganizationValues } from './CreateOrganizationOverlay.types';

export const initialFormValues: CreateOrganizationValues = {
  name: '',
  description: '',
  companyName: '',
  email: '',
  vatNumber: '',
  language: DefaultLanguage,
  thumbnail: null,
  thumbnailsOptions: [],
  address: {
    line1: '',
    line2: undefined,
    line3: undefined,
    postalCode: '',
    city: '',
    state: '',
    countryCode: 'at',
  },
};

export const getInitialState = (): CreateOrganizationValues => ({
  ...initialFormValues,
  thumbnailsOptions: getDummyArray({ length: 4 }).map(seed => ({ type: 'seed', seed })),
});

export const step1ValidationSchema = Yup.object({
  name: Yup.string()
    .trim()
    .min(KubernetesIdentifier.MinLength, 'min_length')
    .max(KubernetesIdentifier.MaxLength, 'max_length')
    .matches(KubernetesIdentifier.Regex, 'invalid')
    .required('empty'),
  description: Yup.string().trim().max(200, 'max_length'),
  companyName: Yup.string().trim().required('empty'),
  email: Yup.string().trim().email('invalid_email'),
  language: Yup.string().trim().required('empty'),
  vatNumber: Yup.string().trim(),
  thumbnail: Yup.mixed(),
  thumbnailsOptions: Yup.mixed(),
});

export const step2ValidationSchema = Yup.object({
  address: Yup.object({
    line1: Yup.string().trim().required('empty'),
    line2: Yup.string().trim().nullable(),
    line3: Yup.string().trim().nullable(),
    postalCode: Yup.string().trim().required('empty'),
    city: Yup.string().trim().required('empty'),
    state: Yup.string().trim().nullable(),
    countryCode: Yup.string().required('empty').notOneOf([0], 'empty'),
  }),
});
